import { writable } from "svelte/store";
export const geolocStore = writable({ status: 'idle' });
export const geolocErrorShownStore = writable(false);
